// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class BmsGetNextBusinessDaysRequestModel {
    'transactionId': number;
    'startingDate': string;
    'numberDays': number;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof BmsGetNextBusinessDaysRequestModel>> = [
        {
            "name":     "transactionId",
            "baseName": "transactionId",
            "type":     "number"
        },
        {
            "name":     "startingDate",
            "baseName": "startingDate",
            "type":     "string"
        },
        {
            "name":     "numberDays",
            "baseName": "numberDays",
            "type":     "number"
        },
    ];

    static getAttributeTypeMap() {
        return BmsGetNextBusinessDaysRequestModel.attributeTypeMap;
    }
}
